import type { Position } from "../types/grid.js";

/**
 * Grid distance helpers.
 *
 * Canonical home for the two distance metrics used across the engine:
 *   - **Chebyshev** (king-move): `max(|dx|, |dz|)`. Matches square-grid
 *     range gates — a target N cells away in any direction (including
 *     diagonals) is within range N. Use for sight cones, leash
 *     radii, and camp-safety checks.
 *   - **Manhattan** (rook-move): `|dx| + |dz|`. Matches the noise and
 *     detection propagation model where diagonals cost 2 steps. Use
 *     for hearing and proximity detection to stay consistent with
 *     `NoiseBroadcast`.
 *
 * Pure, no allocations. Defined once so every consumer behaves
 * identically and future enhancements (e.g. 3D `y` axis) land in one place.
 */

export function chebyshev(a: Position, b: Position): number {
  return Math.max(Math.abs(a.x - b.x), Math.abs(a.z - b.z));
}

export function manhattan(a: Position, b: Position): number {
  return Math.abs(a.x - b.x) + Math.abs(a.z - b.z);
}
